import React from 'react';
import { ProgressBar } from '@yuhuinc/ui-library';
import styled from 'styled-components';
import LeaseHeader from './LeaseHeader';
import { media } from 'helpers/MediaHelper';

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 24px;
  flex-direction: row;
  ${media.mobile`
    flex-direction: column;
  `};
`;

export default function LeaseHeaderProgress({ lease, stepsFilled, totalSteps }) {
  return (
    <StyledHeader>
      <LeaseHeader lease={lease} />
      <div>
        <ProgressBar stepsFilled={stepsFilled} totalSteps={totalSteps} />
      </div>
    </StyledHeader>
  );
}
